// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__2HqGp","item":"styles_item__1aMm6","circle":"styles_circle__1Nx8d"};